<rt-infobox
  [heading]="
    'app.requisitions.details_page.rejected_infobox.heading'
      | translate: { adminName: rejectionAdminName }
  "
  iconName="error"
  type="error"
  [isDismissible]="false"
  margin-bottom
>
  {{ 'app.requisitions.details_page.rejected_infobox.description' | translate }}
  <div
    #rejectMessageText
    class="rejection-reason"
    [style.max-height]="
      messageCollapsed && hasExpandButton ? COLLAPSED_MESSAGE_MAX_HEIGHT + 'px' : 'initial'
    "
  >
    <span>{{ requisition?.rejectionReason }}</span>
  </div>
  @if (hasExpandButton) {
    <div layout margin-top-small>
      <rt-button variant="plain" (click)="toggleShowMore()">
        <rt-icon [name]="messageCollapsed ? 'keyboard-arrow-down' : 'keyboard-arrow-up'" />
        <span>
          {{ (messageCollapsed ? 'app.common.show_more' : 'app.common.show_less') | translate }}
        </span>
      </rt-button>
    </div>
  }
</rt-infobox>
